export const PALETTE = ["#3d68b1", "#3F6B4E", "#8B6E4A", "#7c5cad", "#b1543d", "#3d8fb1", "#a0763d", "#54748c"];

export function projectColor(id) {
  let h = 0;
  for (let i = 0; i < (id || "").length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

export function initials(name) {
  return (name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
}

export function toISO(d) {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export function firstOfMonth(d) {
  const x = new Date(d);
  return toISO(new Date(x.getFullYear(), x.getMonth(), 1));
}

export function fmtDate(s) {
  if (!s) return "";
  const [y, m, d] = s.split("-");
  return `${d}/${m}/${y}`;
}

export function nextDay(s) {
  const d = new Date(s + "T00:00:00");
  d.setDate(d.getDate() + 1);
  return toISO(d);
}

// poziție fracționară (în luni) a unei date în fereastra de luni afișate
export function tlPos(dateStr, months) {
  const N = months.length;
  if (dateStr < months[0].start) return 0;
  if (dateStr > months[N - 1].end) return N;
  const idx = months.findIndex((m) => dateStr >= m.start && dateStr <= m.end);
  const d = new Date(dateStr + "T00:00:00");
  const dim = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
  return idx + (d.getDate() - 1) / dim;
}

export const STATE_LABEL = {
  permanent: "alocare permanentă",
  ending: "se eliberează în interval",
  ended: "alocare încheiată",
  future: "începe ulterior",
  active: "alocare activă",
};

export function barSpan(m, months, today, horizonEnd) {
  const N = months.length;
  const winStart = months[0].start, winEnd = months[N - 1].end;
  const hEnd = horizonEnd || winEnd;
  const s = m.start_date || null, e = m.end_date || null;
  if (s && s > winEnd) return { out: true, reason: `începe ${fmtDate(s)} (după interval)` };
  if (e && e < winStart) return { out: true, reason: `încheiat ${fmtDate(e)} (înainte de interval)` };
  const l = s ? tlPos(s, months) : 0;
  const r = e ? tlPos(nextDay(e), months) : N;
  let state = "active";
  if (m.permanent) state = "permanent";
  else if (e && e < today) state = "ended";
  else if (e && e >= today && e <= hEnd) state = "ending";
  else if (s && s > today) state = "future";
  return {
    left: (l / N) * 100,
    width: Math.max(((r - l) / N) * 100, 0.8),
    state,
    openEnd: !e,
    openStart: !s,
  };
}
